import React from "react";
import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Nav,
  Navbar,
  Form,
  Button,
  Table,
  InputGroup,
  Modal,
  Card,
} from "react-bootstrap";

import "./Modalscss/modal.css";

const Transactionsubmitmodal = ({ submitTransaction, handleCloseModal , text="something" }) => {
  const [fourShow, setFourShow] = useState(false);

  return (
    <>
      {/* <Button
        variant="custombtn2"
        className="py-2 w-100 fw-bold mb-3"
        onClick={() => setFourShow(true)}
      >
        Transaction Submit
      </Button> */}

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        size="md"
        // show={fourShow}
        // onHide={() => setFourShow(false)}
        show={submitTransaction} // Control the visibility of the modal
        onHide={handleCloseModal} // Function to close the modal
        centered
        className="modalBox"
        backdrop= "static"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-inner px-5 pb-3">
            <div className="modal_block">
              <div className="formDiv">
                <Row>
                  <Col lg={12} md={12} sm={12} className="pt-4 mb-3">
                    <div className="text-center py-3 mb-3">
                      <img
                        src="assets/icons/trans_submitIcon.svg"
                        alt=" trans_submitIcon"
                        className=" trans_submitIcon"
                      />
                    </div>
                    <div className="text-center">
                      <h3 className=" text-primary fs-3">
                        Transaction Submitted
                      </h3>
                      <h3 className="text-primary fs-3">{text}</h3>
                    </div>

                    <div className="text-center mt-3">
                      <Button
                        variant="custombtn2"
                        className="py-2 w-100 fw-bold"
                        onClick={handleCloseModal}
                      >
                        CLOSE
                      </Button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Transactionsubmitmodal;
